import { RiPercentLine } from 'react-icons/ri'
import styles from './PriceCalculator.module.css'

interface PriceCalculatorProps {
    pricePerMillar: number
    basePricePerMillar?: number
    quantity: number
    shippingCost: number
    discount?: number
    documentWidth?: number
    documentHeight?: number
    printWidth?: number
    printHeight?: number
}

export function PriceCalculator({
    pricePerMillar,
    basePricePerMillar,
    quantity,
    shippingCost,
    discount,
    documentWidth,
    documentHeight,
    printWidth,
    printHeight,
}: PriceCalculatorProps) {
    const subtotal = pricePerMillar * quantity
    const total = subtotal + shippingCost
    const hasDiscount = discount && discount > 0 && basePricePerMillar && basePricePerMillar > pricePerMillar

    const formatSoles = (amount: number) => `S/ ${amount.toFixed(2)}`

    const hasDimensions = documentWidth !== undefined && documentHeight !== undefined
    const hasPrintDimensions = printWidth !== undefined && printHeight !== undefined
    const sizeMismatch =
        hasDimensions &&
        hasPrintDimensions &&
        (documentWidth !== printWidth || documentHeight !== printHeight)

    return (
        <div className={styles.calculator}>
            {hasDimensions && (
                <div className={styles.docInfo}>
                    <div className={styles.row}>
                        <span>Tamaño del diseño</span>
                        <span>{documentWidth} × {documentHeight} mm</span>
                    </div>
                    {hasPrintDimensions && (
                        <>
                            <div className={styles.row}>
                                <span>Tamaño de impresión</span>
                                <span>{printWidth} × {printHeight} mm</span>
                            </div>
                            {sizeMismatch && (
                                <p className={styles.sizeNote}>
                                    El diseño se ajustará al tamaño de impresión
                                </p>
                            )}
                        </>
                    )}
                    <div className={styles.divider} />
                </div>
            )}

            <div className={styles.row}>
                <span>Precio por millar</span>
                <span className={hasDiscount ? styles.discountedPrice : ''}>
                    {hasDiscount && (
                        <span className={styles.originalPrice}>{formatSoles(basePricePerMillar)}</span>
                    )}
                    {formatSoles(pricePerMillar)}
                </span>
            </div>
            {hasDiscount && (
                <div className={`${styles.row} ${styles.discountRow}`}>
                    <span><RiPercentLine style={{ verticalAlign: 'middle', marginRight: 4 }} />Descuento por volumen</span>
                    <span>−{discount.toFixed(0)}%</span>
                </div>
            )}
            <div className={styles.row}>
                <span>Cantidad</span>
                <span>{quantity} millar(es)</span>
            </div>
            <div className={styles.row}>
                <span>Subtotal</span>
                <span>{formatSoles(subtotal)}</span>
            </div>
            <div className={styles.row}>
                <span>Envío</span>
                <span>{shippingCost > 0 ? formatSoles(shippingCost) : 'Gratis'}</span>
            </div>
            <div className={styles.divider} />
            <div className={`${styles.row} ${styles.total}`}>
                <span>Total</span>
                <span>{formatSoles(total)}</span>
            </div>
        </div>
    )
}
